// extracted by mini-css-extract-plugin
export default {"fotostudioButton":"Button_fotostudioButton__woET1","box":"Button_box__1Lk7C","active":"Button_active__J6d2j"};